export enum InventoriesColumns {
  Location = 'location_name',
  LocationExternalId = 'location_external_id',
  SkuName = 'sku_name',
  SkuExternalId = 'sku_external_id',
  SkuDescription = 'sku_description',
  Product = 'product',
  ProductExternalId = 'product_external_id',
  Style = 'style_names',
  Size = 'size_names',
  Color = 'color_names',
  Category = 'category_names',
  AG = 'assortment_group',
  Department = 'department',
  DepartmentId = 'department_id',
  UnitPrice = 'unit_price',
  Brand = 'brand_names',
  Season = 'season_names',
  TargetMarket = 'target_market_names',
  Replenishment = 'replenishment',
  ReplenishmentTime = 'replenishment_time',
  ShipmentDays = 'shipment_days',
  OptimalStock = 'optimal_stock',
  OptimalStockVariance = 'optimal_stock_variance',
  OptimalStockVariancePercentage = 'optimal_stock_variance_percentage',
  InventoryNeeded = 'inventory_needed',
  Stock = 'stock',
  WhInventory = 'wh_inventory',
  Sold = 'sold',
  SaleRate = 'sale_rate',
  Coverage = 'coverage',
  ReplenishmentGap = 'replenishment_gap',
  Constraints = 'constraints',
  SpecialEvent = 'special_event_names',
  DaysSinceAllocation = 'days_since_allocation',
  SiteQty = 'site_qty',
  MasterSkuName = 'master_sku_name',
  MasterSkuExternalId = 'master_sku_external_id',
  LastUpdated = 'last_updated',
  StaplesStock = 'staples_stock',
}
